import {
  Settings,
  Trash2,
  LogOut,
  Swords,
  Skull,
  Zap,
  Beaker,
  DoorOpen,
  FastForward,
  Hexagon,
  Shield,
  ShieldCheck,
  Circle,
  Sparkles as SparklesIcon,
  Heart,
  Sword,
  Coins,
  Gem,
  Lock,
  type LucideProps,
} from 'lucide-react';

/**
 * Curated icon registry — only the ones the game actually uses.
 * Lucide ships ~3000 icons; importing by name lets Vite tree-shake the bundle
 * down to just what we reference. Adding a new icon = `import { Foo }` here.
 */
const ICON_REGISTRY = {
  settings: Settings,
  trash: Trash2,
  logout: LogOut,
  swords: Swords,
  skull: Skull,
  zap: Zap,
  beaker: Beaker,
  door: DoorOpen,
  forward: FastForward,
  hexagon: Hexagon,
  shield: Shield,
  shield_check: ShieldCheck,
  circle: Circle,
  sparkles: SparklesIcon,
  heart: Heart,
  sword: Sword,
  coins: Coins,
  gem: Gem,
  lock: Lock,
} as const;

export type IconName = keyof typeof ICON_REGISTRY;

interface Props extends LucideProps {
  name: IconName;
}

/**
 * Themed wrapper around Lucide icons. Defaults to `currentColor` so an icon
 * inherits the surrounding text color (cyan accents, danger red, etc.) and
 * stroke-width 1.75 for a slightly bolder line that reads clearly at 16-20 px.
 */
export function Icon({ name, size = 18, strokeWidth = 1.75, ...rest }: Props) {
  const C = ICON_REGISTRY[name];
  return <C size={size} strokeWidth={strokeWidth} {...rest} />;
}
